import { RouteObject } from 'react-router-dom'
import membersRoutes from './members/routes'
import quickTeamsRoute from './quickTeams/routes'
import securityRoutes from './security/routes'
import staffRoutes from './staff/routes'
import teamsRoutes from './teams/routes'

const routes: RouteObject[] = [
  ...membersRoutes,
  ...staffRoutes,
  ...securityRoutes,
  ...teamsRoutes,
  ...quickTeamsRoute,
]

export default routes
